<style scoped lang="less">
  .kb-tip {
    color: #808695;
    margin: 8px 0 16px;
    font-size: 12px;
  }
  .search {
    text-align: right;
    margin-bottom: 12px;
  }
  .search .left {
    float: left;
    text-align: left;
  }
  .browse-bar {
    margin-bottom: 10px;
  }
  .browse-bar .crumb {
    display: inline-block;
    margin-right: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .browse-bar .crumb.current {
    color: #515a6e;
    cursor: default;
  }
  .folder-link {
    color: #2d8cf0;
    cursor: pointer;
  }
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>知识库</Breadcrumb-item>
        <Breadcrumb-item>库管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <p class="kb-tip">上传与建库在此完成；全局助手只做问答。新建可同步创建 IMA 库；备份目录由网盘超管自动创建。</p>
    <div class="search">
      <div class="left">
        <Input v-model="keyword" placeholder="名称/外部ID" style="width: 220px; margin-right: 8px;" @on-enter="load"></Input>
        <Button @click="load">查询</Button>
      </div>
      <Button type="primary" :loading="syncing" @click="openSync">从 IMA 同步</Button>
      <Button style="margin-left: 8px;" @click="openSave()">新建知识库</Button>
    </div>
    <Table border :columns="columns" :data="rows" :loading="loading"></Table>

    <Modal v-model="syncModal" title="从 IMA 同步知识库">
      <Form :label-width="110">
        <Form-item label="远程知识库">
          <Select v-model="syncExternalId" filterable clearable :loading="remoteLoading" placeholder="下拉选择或下方手输" style="width: 100%;">
            <Option v-for="item in remoteOptions" :value="item.id" :key="item.id">{{ item.name }}（{{ item.id }}）</Option>
          </Select>
        </Form-item>
        <Form-item label="或手输 ID">
          <Input v-model="syncExternalIdManual" placeholder="IMA knowledge_base_id"></Input>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="syncModal=false">取消</Button>
        <Button type="primary" :loading="syncing" @click="doSync">同步</Button>
      </div>
    </Modal>

    <Modal v-model="saveModal" title="保存知识库">
      <Form :label-width="120">
        <Form-item label="名称" required>
          <Input v-model="form.name" placeholder="知识库名称"></Input>
        </Form-item>
        <Form-item v-if="!form.id" label="同步创建 IMA">
          <i-switch v-model="form.createRemote">
            <span slot="open">开</span>
            <span slot="close">关</span>
          </i-switch>
          <span class="kb-tip" style="margin-left: 8px;">开：后台调 IMA 建库并回填 ID；关：需填已有外部 ID</span>
        </Form-item>
        <Form-item v-if="form.id || !form.createRemote" label="外部库 ID" :required="!form.id && !form.createRemote">
          <Input v-model="form.externalKbId" :disabled="!!form.id" placeholder="已有 IMA knowledge_base_id"></Input>
        </Form-item>
        <Form-item label="状态">
          <Select v-model="form.status">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </Form-item>
        <Form-item label="备注">
          <Input v-model="form.remark"></Input>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="saveModal=false">取消</Button>
        <Button type="primary" :loading="saving" @click="doSave">保存</Button>
      </div>
    </Modal>

    <Modal v-model="browseModal" title="浏览知识库" width="820">
      <div class="browse-bar">
        <span class="crumb" @click="browseGoRoot">根目录</span>
        <span v-for="(c, idx) in browseCrumbs" :key="idx">
          / <span :class="['crumb', idx === browseCrumbs.length - 1 ? 'current' : '']" @click="browseGoCrumb(idx)">{{ c.name }}</span>
        </span>
        <Input v-model="browseKeyword" placeholder="关键词搜索" style="width: 180px; margin-left: 12px;" @on-enter="doBrowseSearch"></Input>
        <Button size="small" style="margin-left: 6px;" @click="doBrowseSearch">搜索</Button>
        <Button size="small" style="margin-left: 6px;" @click="browseReload">刷新</Button>
      </div>
      <Table border size="small" :columns="browseColumns" :data="browseRows" :loading="browseLoading"></Table>
      <p v-if="!browseLoading && (!browseRows || !browseRows.length)" class="kb-tip">暂无文件</p>
      <div slot="footer">
        <Button type="primary" @click="browseModal=false">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="uploadModal" title="上传到知识库">
      <p class="kb-tip">上传写入 IMA，并备份到网盘（仅网盘超管可见）。</p>
      <p>目标库：{{ uploadTarget && uploadTarget.name }}</p>
      <input type="file" ref="fileInput" @change="onFileChange">
      <div slot="footer">
        <Button @click="uploadModal=false">取消</Button>
        <Button type="primary" :loading="uploading" @click="doUpload">开始上传</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { KB_URI } from '@/tools/kbApi'

  export default {
    data () {
      let self = this
      return {
        keyword: '',
        loading: false,
        rows: [],
        syncModal: false,
        syncExternalId: '',
        syncExternalIdManual: '',
        syncing: false,
        remoteLoading: false,
        remoteOptions: [],
        saveModal: false,
        saving: false,
        form: { id: null, externalKbId: '', name: '', status: 1, remark: '', createRemote: true },
        browseModal: false,
        browseLoading: false,
        browseTarget: null,
        browseParentId: '',
        browseKeyword: '',
        browseRows: [],
        browseCrumbs: [],
        uploadModal: false,
        uploadTarget: null,
        uploadFile: null,
        uploading: false,
        columns: [
          { title: 'ID', key: 'id', width: 80, align: 'center' },
          { title: '名称', key: 'name', minWidth: 140 },
          { title: '外部 ID', key: 'externalKbId', minWidth: 160 },
          { title: '提供商', key: 'provider', width: 90, align: 'center' },
          {
            title: '状态',
            width: 90,
            align: 'center',
            render: (h, p) => h('span', p.row.status === 1 ? '启用' : '停用')
          },
          {
            title: '备份目录',
            width: 110,
            align: 'center',
            render: (h, p) => h('span', p.row.backupNodeId || '未建')
          },
          { title: '更新时间', key: 'gmtModified', minWidth: 160 },
          {
            title: '操作',
            minWidth: 200,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('a', { on: { click: () => self.openSave(row) } }, '编辑'),
                h('span', { class: 'divider' }, ' | '),
                h('a', { on: { click: () => self.openBrowse(row) } }, '浏览'),
                h('span', { class: 'divider' }, ' | '),
                h('a', { on: { click: () => self.openUpload(row) } }, '上传')
              ])
            }
          }
        ],
        browseColumns: [
          {
            title: '名称',
            minWidth: 220,
            render: (h, p) => {
              let row = p.row
              if (row.type === 'folder') {
                return h('span', {
                  class: 'folder-link',
                  on: { click: () => self.browseEnterFolder(row) }
                }, '📁 ' + (row.name || row.title || row.folder_id))
              }
              return h('span', (row.name || row.title || row.media_id || '-'))
            }
          },
          {
            title: '类型',
            width: 90,
            align: 'center',
            render: (h, p) => h('span', p.row.type === 'folder' ? '文件夹' : '文件')
          },
          { title: 'ID', minWidth: 160, render: (h, p) => h('span', p.row.media_id || p.row.folder_id || '-') },
          { title: '摘要', key: 'snippet', minWidth: 160 }
        ]
      }
    },
    created () {
      this.load()
    },
    methods: {
      load () {
        this.loading = true
        this.$http.post(KB_URI.baseList, { keyword: this.keyword }).then(res => {
          this.loading = false
          if (res && res.status === 'ok') {
            this.rows = res.data || []
          }
        }).catch(() => { this.loading = false })
      },
      loadRemoteBases () {
        this.remoteLoading = true
        this.$http.post(KB_URI.providerBases, { keyword: '' }).then(res => {
          this.remoteLoading = false
          if (res && res.status === 'ok') {
            let remote = (res.data && res.data.remoteList) || {}
            let list = remote.list || remote.info_list || []
            this.remoteOptions = (list || []).map(it => ({
              id: it.knowledge_base_id || it.id,
              name: it.name || it.knowledge_base_id || it.id
            })).filter(it => !!it.id)
          }
        }).catch(() => { this.remoteLoading = false })
      },
      openSync () {
        this.syncExternalId = ''
        this.syncExternalIdManual = ''
        this.syncModal = true
        this.loadRemoteBases()
      },
      doSync () {
        let id = (this.syncExternalIdManual || this.syncExternalId || '').trim()
        if (!id) {
          this.$Message.warning('请选择或填写外部库 ID')
          return
        }
        this.syncing = true
        this.$http.post(KB_URI.baseSync, { externalKbId: id }).then(res => {
          this.syncing = false
          if (res && res.status === 'ok') {
            this.$Message.success('同步成功')
            this.syncModal = false
            this.load()
          }
        }).catch(() => { this.syncing = false })
      },
      openSave (row) {
        if (row) {
          this.form = {
            id: row.id,
            externalKbId: row.externalKbId,
            name: row.name,
            status: row.status,
            remark: row.remark || '',
            createRemote: false
          }
        } else {
          this.form = { id: null, externalKbId: '', name: '', status: 1, remark: '', createRemote: true }
        }
        this.saveModal = true
      },
      doSave () {
        if (!this.form.name) {
          this.$Message.warning('名称必填')
          return
        }
        if (!this.form.id && !this.form.createRemote && !this.form.externalKbId) {
          this.$Message.warning('请填写外部库 ID，或打开「同步创建 IMA」')
          return
        }
        let payload = {
          id: this.form.id,
          name: this.form.name,
          status: this.form.status,
          remark: this.form.remark
        }
        if (this.form.id) {
          payload.externalKbId = this.form.externalKbId
        } else if (!this.form.createRemote) {
          payload.externalKbId = this.form.externalKbId
        }
        // createRemote 时不传 externalKbId，后端调 create_knowledge_base
        this.saving = true
        this.$http.post(KB_URI.baseSave, payload).then(res => {
          this.saving = false
          if (res && res.status === 'ok') {
            this.$Message.success('已保存')
            this.saveModal = false
            this.load()
          }
        }).catch(() => { this.saving = false })
      },
      openBrowse (row) {
        this.browseTarget = row
        this.browseParentId = ''
        this.browseKeyword = ''
        this.browseCrumbs = []
        this.browseModal = true
        this.browseReload()
      },
      browseReload () {
        if (!this.browseTarget) {
          return
        }
        this.browseLoading = true
        this.$http.post(KB_URI.browse, {
          kbBaseId: this.browseTarget.id,
          parentId: this.browseParentId || '',
          keyword: this.browseKeyword || ''
        }).then(res => {
          this.browseLoading = false
          if (res && res.status === 'ok') {
            let remote = (res.data && res.data.remote) || {}
            this.browseRows = remote.list || []
          }
        }).catch(() => { this.browseLoading = false })
      },
      doBrowseSearch () {
        this.browseReload()
      },
      browseEnterFolder (row) {
        let fid = row.folder_id
        if (!fid) {
          return
        }
        this.browseCrumbs.push({ id: fid, name: row.name || row.title || fid })
        this.browseParentId = fid
        this.browseKeyword = ''
        this.browseReload()
      },
      browseGoRoot () {
        this.browseCrumbs = []
        this.browseParentId = ''
        this.browseKeyword = ''
        this.browseReload()
      },
      browseGoCrumb (idx) {
        if (idx < 0 || idx >= this.browseCrumbs.length - 1) {
          return
        }
        this.browseCrumbs = this.browseCrumbs.slice(0, idx + 1)
        this.browseParentId = this.browseCrumbs[idx].id
        this.browseKeyword = ''
        this.browseReload()
      },
      openUpload (row) {
        this.uploadTarget = row
        this.uploadFile = null
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
        this.uploadModal = true
      },
      onFileChange (e) {
        let files = e.target.files
        this.uploadFile = files && files.length ? files[0] : null
      },
      doUpload () {
        if (!this.uploadTarget) {
          return
        }
        if (!this.uploadFile) {
          this.$Message.warning('请选择文件')
          return
        }
        let fd = new FormData()
        fd.append('kbBaseId', this.uploadTarget.id)
        fd.append('file', this.uploadFile)
        this.uploading = true
        this.$http.post(KB_URI.upload, fd).then(res => {
          this.uploading = false
          if (res && res.status === 'ok') {
            let tip = (res.data && res.data.message) || '上传成功'
            if (res.data && res.data.backupStatus === 2) {
              tip += '（网盘备份失败：' + ((res.data && res.data.base && '') || '') + (res.data.lastError || '见服务端日志') + '）'
              // lastError 不在 data 顶层，提示简化
              tip = ((res.data && res.data.message) || '上传成功') + '（IMA 已成功；网盘备份失败，非超管或目录未建）'
            } else if (res.data && res.data.backupStatus === 1) {
              tip = ((res.data && res.data.message) || '上传成功') + '（已双写网盘）'
            }
            this.$Message.success(tip)
            this.uploadModal = false
            this.uploadFile = null
            if (this.$refs.fileInput) {
              this.$refs.fileInput.value = ''
            }
            this.load()
          }
        }).catch(() => { this.uploading = false })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// KbIndex.vue?eed30146